// @ts-ignore
import { env } from "configs/EnvironmentConfig";
import { HmacSHA256, enc } from "crypto-js";
import PropTypes from "prop-types";
import React, { useEffect, useImperativeHandle, useRef } from "react";
import { useToasts } from "react-toast-notifications";

const SocketPrintBarCode = React.forwardRef((props, ref) => {
  const socketRef = useRef(null);
  const { handleConnect } = props;

  const { addToast } = useToasts();

  useEffect(() => {
    socketRef.current = new WebSocket(env.SOCKET_PRINTER_URL);
    socketRef.current.onopen = event => {
      console.log(
        "🚀 ~ file: SocketPrintBarCode.js:37 ~ useEffect ~ event:",
        event
      );
      handleConnect({
        isConnect: true,
        message: "",
      });
      console.log("WebSocket connection established.");
      // Perform any actions upon successful connection
    };

    socketRef.current.onclose = event => {
      console.log("WebSocket connection closed.", event);
      handleConnect({
        isConnect: false,
        message: "Print tool chưa được cài đặt",
      });
      // Handle the WebSocket connection closed event
    };

    socketRef.current.onerror = error => {
      handleConnect({
        isConnect: false,
        message: "",
      });
      console.error("WebSocket error:", error);
      // Handle any WebSocket errors
    };

    socketRef.current.onmessage = function (event) {
      // Handle the response here
      const response = JSON.parse(event.data);
      console.log(
        "🚀 ~ file: SocketPrintBarCode.js:45 ~ useEffect ~ response:",
        response
      );
      switch (response?.statusCode) {
        case "PRINT_PENDING":
          addToast("Chờ in Barcode", {
            appearance: "success",
            autoDismiss: true,
          });
          break;
        case "PRINTER_READY":
          handleConnect({
            isConnect: true,
            message: "",
          });
          break;
        case "PRINTER_NOT_AVAILABLE":
          handleConnect({
            isConnect: false,
            message: "Tạm dừng",
          });
          break;
        case "PRINT_QUEUE_IS_CLEAR":
          handleConnect({
            isConnect: false,
            message: "Hủy tất cả Barcode cần in còn trong hàng đợi",
          });
          break;
        default:
          break;
      }
    };

    return () => {
      // Clean up the WebSocket connection upon component unmount
      socketRef.current.close();
    };
  }, []);

  useImperativeHandle(ref, () => ({
    printBase64({ base64 }) {
      const data = {
        mode: "base64",
        base64: base64,
      };
      const messageFinal = JSON.stringify(data);

      const hash = HmacSHA256(
        messageFinal,
        env.SOCKET_PRINTER_HMAC_SHA256_KEY
      ).toString(enc.Hex);

      socketRef.current.send(
        JSON.stringify({
          key: hash,
          ...data,
        })
      );
    },
  }));

  return <></>;
});

SocketPrintBarCode.propTypes = {
  handleConnect: PropTypes.any,
};

export default SocketPrintBarCode;
